import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';

/**
 * Get file data for files by filepermission ids
 * @param {array} filepermissionIds - Array of filepermission ids
 * @returns - File data for files
 */
export const getFileSizeByFilePermissions = async (filepermissionIds) => {
    let apiPath = `files/get-file-size-by-filepermissions`;

    const body = {
        filepermissionIds: filepermissionIds,
    };

    const request = {
        // url: `http://localhost:3001/${apiPath}`,
        url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
        host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
        path: apiPath,
        method: 'POST',
        region: Config.AWS_REGION,
        service: 'execute-api',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
        data: body,
    };

    const signedRequest = await createSignedRequest(request);

    const response = await axios(signedRequest);

    return response.data;
};